// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contemplating {
  display: inline-flex;
  color: #9ca3af;
  font-style: italic;
  font-size: inherit;
  line-height: inherit;
}

.contemplating__char {
  white-space: pre;
  animation: contemplatingWave 1.8s ease-in-out infinite;
}

@keyframes contemplatingWave {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}

.dark .contemplating {
  color: #6b7280;
}

.specific-skill-guidance-streaming::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: contemplatingBlinkCursor 1s step-end infinite;
  color: #6b7280;
  font-weight: 500;
}

.dark .specific-skill-guidance-streaming::after {
  color: #9ca3af;
}

@keyframes contemplatingBlinkCursor {
  50% { opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ContemplatingIndicator.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,wDAAwD;EACxD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,MAAM,UAAU,EAAE;AACpB","sourcesContent":[".contemplating {\n  display: inline-flex;\n  color: #9ca3af;\n  font-style: italic;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.contemplating__char {\n  white-space: pre;\n  animation: contemplatingWave 1.8s ease-in-out infinite;\n}\n\n@keyframes contemplatingWave {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.2; }\n}\n\n.dark .contemplating {\n  color: #6b7280;\n}\n\n.specific-skill-guidance-streaming::after {\n  content: '|';\n  display: inline-block;\n  margin-left: 2px;\n  animation: contemplatingBlinkCursor 1s step-end infinite;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.dark .specific-skill-guidance-streaming::after {\n  color: #9ca3af;\n}\n\n@keyframes contemplatingBlinkCursor {\n  50% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
